import { useTranslation } from "react-i18next";

const ComplaintResponsePolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="h-auto w-full flex flex-col gap-5">
      <h1 className="uppercase text-4xl font-bold">
        {t("policy.complaint.title")}
      </h1>
      <div className="flex flex-col gap-5">
        <div className="text-justify font-normal leading-8">
          {t("policy.complaint.text1")}
        </div>
        <div className="text-justify font-normal leading-8">
          {t("policy.complaint.text2")}
        </div>
        <div className="text-justify font-normal leading-8">
          {t("policy.complaint.text3")}
        </div>
        <div className="text-justify font-normal leading-8">
          {t("policy.complaint.text4")}
        </div>
        <p>
          Upon receiving your passport or documents, it is your responsibility
          to verify:
        </p>
        <ul className="list-disc list-inside">
          <li>
            Visa Requests: That the visas match your travel dates, destinations,
            and purpose (tourism, business, etc.).
          </li>
          <li>
            Document Requests: That all requested documents are present and
            correctly certified.
          </li>
        </ul>
        <p>
          Notify TRAVERSIA immediately via email if any discrepancies are found.
        </p>
        <p>
          Issuing authorities determine the final outcome. TRAVERSIA cannot
          guarantee approvals or specific processing timelines.
        </p>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-2xl">
            {t("policy.complaint.procedureStep1")}
          </h2>
          <div className="">
            <span className="">{t("policy.complaint.procedureStep2")}</span>
          </div>
          <div className="">
            <span className="">{t("policy.complaint.procedureStep3")}</span>
          </div>
        </div>
        <div className="my-12 text-center border-b-2"></div>
        <div className="flex flex-col items-center justify-center text-black">
          <h2 className="mb-12 text-2xl font-bold">
            {t("policy.complaint.supportContactTitle")}
          </h2>
          <ul>
            <li className="mb-2 flex justify-between">
              <span className="w-24 mr-8">
                {t("policy.complaint.supportNameTitle")}
              </span>
              <span>{t("policy.complaint.supportName")}</span>
            </li>
            <li className="mb-2 flex justify-between">
              <span className="w-24 mr-8">
                {t("policy.complaint.supportPhoneTitle")}
              </span>
              <span>{t("policy.complaint.supportPhone")}</span>
            </li>
            <li className="mb-2 flex justify-between">
              <span className="w-24 mr-8">
                {t("policy.complaint.supportEmailTitle")}
              </span>
              <span>{t("policy.complaint.supportEmail")}</span>
            </li>
            <li className="mb-2 flex items-center justify-between">
              <span className="w-24 mr-8">
                {t("policy.complaint.supportAddressTitle")}
              </span>
              <span className="w-[420px] text-right">
                {t("policy.complaint.supportAddress")}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ComplaintResponsePolicy;
